module.exports = __webpack_public_path__ + "static/media/climate_workplacePollutants_1_landWaterAirPollutants.d0fe9deb.jpg";